function readMore() {
  var textSpan = document.getElementById("more");
  var moreText = document.getElementById("more-text");
  var btnText = document.getElementById("read-more");

  if (textSpan.style.display === "none") {
    textSpan.style.display = "inline";
    btnText.innerHTML = "+ Read more";
    moreText.style.display = "none";
  } else {
    textSpan.style.display = "none";
    btnText.innerHTML = "– Read less";
    moreText.style.display = "inline";
  }
}

function showMoreListings(selector) {
  let button = event.target;
  var textSpan = document.querySelector(selector);

  if (textSpan.style.display === "none") {
    textSpan.style.display = "block";
    button.innerHTML = button.dataset.textLess || "– Show less";
  } else {
    textSpan.style.display = "none";
    button.innerHTML = button.dataset.textMore || "+ Show all";
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.changeEvent = new Event('change', { bubbles: true })

    this.input = this.querySelector('input');

    if (this.input) {
      this.querySelectorAll('button')?.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
    }
    else{
      this.querySelector('select')?.addEventListener('change', e=>{
        this.dispatchEvent(this.changeEvent);
      })
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.className.includes('plus') ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-selector', QuantityInput);


class productOptions extends HTMLElement {
  constructor(){
    super();
    this.JSON = JSON.parse(this.querySelector('script').textContent);
    this.form = this.closest('form');

    this.addEventListener('change', this.change.bind(this));
  }

  getVariant(){
    return this.JSON.find(i=>{
      return Array.from(this.querySelectorAll('select')).map(i=>i.value).toString() == i.options.toString();
    });
  }
  change(){
    this.variant = this.getVariant();

    if(this.variant){
      this.form.querySelector('[name=id]').value = this.variant.id;
      this.updateFields();
    }
    const button = this.form.querySelector('button[name=add]');
    button.toggleAttribute('disabled', !this.variant?.available);
    button.textContent = 'ADD TO CART';
    button.removeAttribute('data-go');
  }

  updateFields(){
    document.querySelectorAll('.js-variants').forEach(i=>{
      i.style.display = i.dataset.variantId == this.variant.id ? null : 'none';
    })
  }
}
customElements.define('product-options', productOptions);


window.addEventListener('DOMContentLoaded', ()=>{
  document.querySelector('.js-add-cart')?.addEventListener('click', e=>{
    e.preventDefault();
    e.stopPropagation();

    const button = e.target.closest('.js-add-cart');

    if(button.dataset.go == 'checkout'){
      location.href = '/checkout';
      return;
    }

    const form = button.closest('form');

    let formData = new FormData(form);
    formData.append('sections', ['cart-live-text']);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if(response.status == 200){
        button.textContent = 'CHECKOUT';
        button.setAttribute('data-go',  'checkout');
      }
      return response.json();
    })
    .then(response => {
      const div = document.createElement('div');
      div.innerHTML = response.sections['cart-live-text'];
      document.querySelectorAll('.js-cart-count')?.forEach(i=>{i.innerHTML = div.textContent.trim()});
    })
    .catch((error) => {
      console.error('Error:', error);
    });

  })
})


class cartSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onChange.bind(this));
  }

  onChange(e) {
    const input = e.target;

    if(!input || input.tagName != 'INPUT') return;

    const formData = {
      id: input.dataset.key,
      quantity: +input.value,
      sections: ['main-cart-page']
    }

    fetch(window.Shopify.routes.root + 'cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log(response);
      return response.json();
    })
    .then(response => {
      this.innerHTML = response.sections['main-cart-page'];
    })
    .catch((error) => {
      console.error('Error:', error);
    });

  }
}

customElements.define('cart-section', cartSection);